/**
 * если указан meta: { title: 'БАЛАБЛА' }, то будет выведен в навбар таб
 *
 * */

import ProfileRouter, { routeName, RedirectOrNull } from './types';

import { createNotificationsRoutes, createRemoteEduRoutes } from '../modules';
import Consultatations from '@/pages/profile/views/consultations/Consultatations.vue';

const Index = () => import('../Index.vue' /* webpackChunkName: "profile" */);
const Info = () => import('../views/info' /* webpackChunkName: "info" */);
const Settings = () =>
  import('../views/settings' /* webpackChunkName: "settings" */);
const Cabinet = () =>
  import('../views/cabinet' /* webpackChunkName: "cabinet" */);
const Favorite = () =>
  import('../views/favorite' /* webpackChunkName: "favorite" */);
const History = () =>
  import('../views/history' /* webpackChunkName: "history" */);
const CareerGuidance = () =>
  import('../views/career-guidance' /* webpackChunkName: "history" */);
const Purchases = () =>
  import('../views/purchases' /* webpackChunkName: "purchases" */);

const PurchasesEvent = () =>
  import(
    '@/pages/profile/views/purchases/pages/purchases-event' /* webpackChunkName: "purchases-event" */
  );
const PurchasesActivity = () =>
  import(
    '@/pages/profile/views/purchases/pages/purchases-activity' /* webpackChunkName: "purchases-event" */
  );
const PurchasesNewEvent = () =>
  import(
    '@/pages/profile/views/purchases/pages/purchases-new-event' /* webpackChunkName: "purchases-event" */
  );

const General = () =>
  import('../views/general' /* webpackChunkName: "general" */);

const AddressSettings = () =>
  import('../views/address' /* webpackChunkName: "address-settings" */);
const InterestsSettings = () =>
  import('../views/interests' /* webpackChunkName: "interests-settings" */);
const Certificate = () =>
  import('../views/certificate' /* webpackChunkName: "certificate" */);
const Education = () =>
  import('../views/education' /* webpackChunkName: "education" */);
const Progress = () =>
  import('../views/progress' /* webpackChunkName: "progress" */);

const AddResult = () =>
  import(
    '../views/progress/forms/resultform' /* webpackChunkName: "resultform" */
  );
const AddCompetition = () =>
  import(
    '../views/progress/forms/competitionform' /* webpackChunkName: "competitionform" */
  );

const Vacancy = () =>
  import('../views/vacancy' /* webpackChunkName: "vacancy" */);

const Study = () => import('../views/study/Study.vue');
const Addittional = () => import('../views/additional/Addittional.vue');

const Work = () => import('../views/work/Work.vue');
const ResultCourses = () => import('../views/resultCourses/ResultCourses.vue');
const AccessPermission = () =>
  import('../views/accessPermission/AccessPermission.vue');

const toName = (value: string) => [routeName.ROOT, value].join('-');

export const childrenRoutes = (redirect: RedirectOrNull = null): Array<any> => {
  return [
    {
      path: 'cabinet',
      component: Cabinet,
      name: toName('cabinet'),
      redirect: { name: toName('favorite') },
    },
    {
      path: 'favorite',
      component: Favorite,
      name: toName('favorite'),
      meta: {
        title: 'Избранное',
        inpath: 'profile-cabinet',
      },
    },
    {
      path: 'history',
      component: History,
      name: toName('history'),
      meta: {
        inpath: 'profile-cabinet',
        title: 'Просмотренное',
      },
    },
    {
      path: 'career-guidance',
      component: CareerGuidance,
      name: toName('career-guidance'),
      meta: {
        inpath: 'profile-cabinet',
        title: 'Профориентация',
        checkApiModules: 'intalent',
      },
    },
    {
      path: 'purchases',
      component: Purchases,
      name: toName('purchases'),
      meta: {
        inpath: 'profile-cabinet',
        title: 'Заявки',
      },
      redirect: { name: toName('purchases-event') },
      children: [
        {
          path: 'event',
          component: PurchasesEvent,
          name: toName('purchases-event'),
        },
        {
          path: 'activity',
          component: PurchasesActivity,
          name: toName('purchases-activity'),
        },
        {
          path: 'new-event',
          component: PurchasesNewEvent,
          name: toName('purchases-new-event'),
        },
      ],
    },
    {
      path: 'education',
      component: Education,
      name: toName('education'),
      meta: {
        title: 'Обучение',
        inpath: 'profile-cabinet',
        checkApiModules: 'remote-edu',
      },
      beforeEnter: () => {
        window.location.assign('/profile/education/schedule/week');
      },
    },
    {
      path: 'result-courses',
      component: ResultCourses,
      name: toName('result-courses'),
      meta: { resultCourses: true, inpath: 'profile-cabinet' },
    },
    {
      path: 'access-permission',
      component: AccessPermission,
      name: toName('access-permission'),
      meta: { accessPermission: true, inpath: 'profile-cabinet' },
    },
    {
      path: 'feedback',
      component: Vacancy,
      name: toName('feedback'),
      meta: {
        checkApiModules: 'vacancies',
        title: 'Трудоустройство',
        inpath: 'profile-cabinet',
      },
    },
    {
      path: 'consultations',
      component: Consultatations,
      name: toName('consultations'),
      meta: {
        checkApiModules: true,
        consultations: true,
        isAuth: true,
        title: 'Консультации',
        inpath: 'profile-cabinet',
      },
    },
    {
      path: 'certificate',
      component: Certificate,
      name: toName('certificate'),
      meta: { pfdod: true, inpath: 'profile-cabinet' },
      beforeEnter: redirect && redirect('hasApiModulePfdod'),
    },
    {
      path: 'progress',
      component: Progress,
      name: toName('progress'),
      meta: { progress: true, inpath: 'profile-cabinet' },
      children: [
        {
          path: 'add',
          component: AddResult,
          name: toName('add'),
          meta: { open: true, inpath: 'profile-cabinet' },
        },
        {
          path: 'competition',
          component: AddCompetition,
          name: toName('competition'),
          meta: { open: true, inpath: 'profile-cabinet' },
        },
      ],
    },
    ...createRemoteEduRoutes({
      redirectTo404: redirect && redirect('hasApiModuleRemoteEdu'),
    }),
  ];
};

export const settingsRoutes = [
  {
    path: 'settings',
    component: General,
    name: toName('settings'),
    meta: { title: 'Основное', inpath: 'profile-settings' },
  },
  {
    path: 'address',
    component: AddressSettings,
    name: toName('settings-address'),
    meta: { title: 'Адрес', inpath: 'profile-settings' },
  },
  {
    path: 'interests',
    component: InterestsSettings,
    name: toName('settings-interests'),
    meta: {
      title: 'Направления',
      inpath: 'profile-settings',
      checkApiModules: 'portfolio',
    },
  },
  {
    path: 'study',
    component: Study,
    name: toName('settings-study'),
    meta: {
      title: 'Учёба',
      inpath: 'profile-settings',
      checkApiModules: 'portfolio',
    },
  },
  {
    path: 'work',
    component: Work,
    name: toName('settings-work'),
    meta: {
      title: 'Работа',
      inpath: 'profile-settings',
      checkApiModules: 'portfolio',
    },
  },
  {
    path: 'settings-progress',
    component: Progress,
    name: toName('settings-progress'),
    meta: {
      title: 'Достижения',
      inpath: 'profile-settings',
      checkApiModules: 'portfolio',
    },
    children: [
      {
        path: 'add',
        component: AddResult,
        name: toName('settings-add'),
        meta: { open: true, inpath: 'profile-settings' },
      },
      {
        path: 'competition',
        component: AddCompetition,
        name: toName('settings-competition'),
        meta: { open: true, inpath: 'profile-settings' },
      },
    ],
  },
  {
    path: 'settings-result-courses',
    component: ResultCourses,
    name: toName('setting-result-courses'),
    meta: {
      title: 'Результаты обучения',
      inpath: 'profile-settings',
      checkApiModules: 'portfolio',
    },
  },
  {
    path: 'additional',
    component: Addittional,
    name: toName('settings-additional'),
    meta: {
      title: 'Дополнительно',
      inpath: 'profile-settings',
      checkApiModules: 'portfolio',
    },
  },
];

const createRoutes = ({ path, redirectTo404 }: ProfileRouter) => {
  const result = {
    path,
    component: Index,
    redirect: { name: toName('cabinet') },
    meta: { isProfile: true },
    children: [
      {
        path,
        component: Info,
        redirect: { name: toName('cabinet') },
        meta: { isInnerRoutes: true },
        children: childrenRoutes(redirectTo404),
      },
      {
        path,
        component: Settings,
        redirect: { name: toName('settings') },
        meta: {
          isInnerSettingsRoutes: true,
          inpath: 'profile-settings',
        },
        children: settingsRoutes,
      },
      ...createNotificationsRoutes({
        path: 'notifications',
        name: toName('notifications'),
        redirectTo404,
      }),
    ],
  };

  return [result];
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/pages/profile/router/index.ts